export default {
  customFieldsList() {
    return [
      {
        title: "Basic",
        icon: "icon-basic",
        value: "basic",
        description: "Basic fields for general use",
        fields: [
          { title: "Text", value: "text" },
          { title: "Number", value: "number" },
          { title: "Url", value: "url" },
          { title: "Date & time", value: "date" },
          { title: "Textarea", value: "textarea" },
          { title: "Boolean", value: "boolean" },
          { title: "Email", value: "email" },
          { title: "Phonenumber", value: "phonenumber" },
          { title: "Image", value: "image" },
          { title: "Dropdown", value: "dropdown" },
          { title: "Money", value: "money" },
          { title: "Signature", value: "signature" },
          { title: "Barcode", value: "barcode" },
          { title: "QR Code", value: "qrcode" },
          { title: "Row ID", value: "row-id" },
          { title: "Rating", value: "rating" },
          { title: "File", value: "file" }
          // { title: "Voting", value: "voting" },
        ]
      },
      {
        title: "Computed",
        icon: "icon-computed",
        value: "computed",
        description: "Computed fields for advanced calculations",
        fields: [
          { title: "Math", value: "math" },
          { title: "Formula", value: "formula" },
          { title: "Template", value: "template" },
          { title: "If > Then > Else", value: "if-then-else" },
          { title: "Query", value: "query" },
          { title: "Relation", value: "relation" },
          { title: "Lookup", value: "loopup" },
          { title: "Rollup", value: "Rollup" },
          { title: "Single value", value: "single-value" },
          { title: "Joined List", value: "joined-list" },
          { title: "Split text", value: "split-text" },
          { title: "Make array", value: "make-array" },
          { title: "Distance", value: "distance" },
          { title: "Generate image", value: "generate-image" },
          { title: "Construct URL", value: "construct-url" }
        ]
      },
      {
        title: "Integrations",
        icon: "icon-integrations",
        value: "integrations",
        description: "Integrations with external services",
        fields: [
          { title: "Webhook", value: "webhook" },
          { title: "API", value: "api" },
          // { title: "Zapier", value: "zapier" },
          // { title: "Integromat", value: "integromat" },
          // { title: "Make", value: "make" },
          { title: "Google Sheets", value: "google-sheets" },
          // { title: "Google Calendar", value: "google-calendar" },
          // { title: "Google Maps", value: "google-maps" },
          // { title: "Slack", value: "slack" },
          // { title: "Discord", value: "discord" },
          { title: "Mapbox - location", value: "location" }
        ]
      }
    ];
  }
};
